import type {
  ITrackerConfig,
  IEventData,
  IEvent,
  TTrackersKeys,
  IAbstractTrackerSystemConfig,
  IWindowGlobals,
  IABVariants,
} from "./TrackerManager.types";
import TrackerManager, { TM } from "./TrackerManager";
import { getTrackerConfig } from "./TrackerData";

import type { IAdvBannerEventMap } from "./ServiceTypes/advertising";
import { AdvBuyEventMmType } from "./ServiceTypes/advertising";

export type {
  ITrackerConfig,
  IEventData,
  IEvent,
  TTrackersKeys,
  IAbstractTrackerSystemConfig,
  IWindowGlobals,
  IABVariants,
  IAdvBannerEventMap,
};

export { TrackerManager, TM, getTrackerConfig, AdvBuyEventMmType };
export default TrackerManager;
